var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatusError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9998 9C15.9998 5.93 14.3598 3.36 11.4998 2.68V2C11.4998 1.17 10.8298 0.5 9.99979 0.5C9.16979 0.5 8.49979 1.17 8.49979 2V2.68C5.62979 3.36 3.99979 5.92 3.99979 9V14L1.99979 16V17H17.9998V16L15.9998 14V9ZM4.14979 0.65L5.57979 2.08C3.53979 3.53 2.17979 5.85 2.02979 8.5H0.0297852C0.169785 5.3 1.74978 2.48 4.14979 0.65ZM19.9698 8.5H17.9698C17.8198 5.85 16.4498 3.53 14.4298 2.08L15.8498 0.65C18.2398 2.48 19.8198 5.3 19.9698 8.5ZM10.3998 19.96C10.2698 19.99 10.1398 20 9.99979 20C8.88978 20 7.99979 19.1 7.98979 18H11.9898C11.9898 18.28 11.9398 18.54 11.8398 18.78C11.5798 19.38 11.0498 19.82 10.3998 19.96Z",
    fill: "#CA3C3D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusError);
export default __webpack_public_path__ + "static/media/status_error.e92063e7125744b33c8d1f3c68ab73c5.svg";
export { ForwardRef as ReactComponent };